import BaseMediaResource from './BaseMediaResource'

class Tour360Resource extends BaseMediaResource {
  get tour360Url() {
    return this.resourceUrl
  }
}
export default Tour360Resource
